export default "__VITE_ASSET__7ed87d9d__"